import * as React from 'react';
import { useAppStore } from '../stores';
import { InputModelWithSource } from '../models';

export default (input: InputModelWithSource) => {
    const { baseCompanySegregationStore } = useAppStore();

    React.useEffect(() => {
        const subscription = baseCompanySegregationStore.baseCompanyChangeSubject.subscribe(() => {
            input.fetchSourceOptions({ ignoreCache: true });
        });

        return () => subscription.unsubscribe();
    }, [input, baseCompanySegregationStore]);
};
